// Versions of the standalone policy documents linked at the signing step (the
// public pages at /privacy.html and /terms.html). Recorded on the member's
// consent so we know which version they accepted. These are SEPARATE documents
// from the Contribution Agreement (agreementTerms.js) — bump each INDEPENDENTLY
// when its page changes, and update that page's "Last updated" line.
export const PRIVACY_VERSION = 'v2-2026-08';
export const TERMS_VERSION = 'v2-2026-08';

// Messaging consent (SMS + WhatsApp; OTP + ongoing payment/account notifications).
// A SEPARATE, versioned consent recorded on member_consents.messaging_consent_version
// (Stage 45) — NOT folded into the hashed Contribution Agreement. Bump when the
// messaging consent wording changes; the WhatsApp dispatch gates on this version.
export const MESSAGING_CONSENT_VERSION = 'v2-2026-08';
